import { message } from 'antd';
import { authHeader } from '../../../helpers/auth-header';
import { client } from '../../../actions';
import uri from '../constants/uri';

const getFileTemplate = async () => {
  try {
    const response = await client.get(`${uri}/template`, {
      headers: authHeader(),
    });
    let data = Buffer.from(response.data, 'base64');
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      'Шаблон файла деб.задолженности для сайта Dispex.xlsx'
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error(error);
    message.error('Не удалось загрузить шаблон файла');
  }
};

export default getFileTemplate;
